import { defineMessages } from 'react-intl';

export default defineMessages({
  totalString: {
    id: 'total',
    description: 'total',
    defaultMessage: 'TOTAL',
  },
});
